import { Row } from 'antd';
import { Modal } from 'components/Modal';
import { BackgroundModalData } from 'components/BackgroundModalData';
import { TextS } from 'components/Text';
import { DestinationType } from 'types/Destination';
import { DestinationTypeDescription } from 'constants/destination';
import { PaymentType } from 'types/Posting';
import theme from 'theme/theme';
import {
	SectionContainer,
	SectionTitle,
	HelperTable,
	HelperThead,
	HelperTh,
	HelperTd,
	HelperTr,
} from './styles';

export type CsvHelperType = 'destination' | 'transfer' | 'all';

export interface IImportCsvHelperModalProps {
	isOpen: boolean;
	onClose: () => void;
}

const ACCOUNT_TYPE_ROWS = [
	{
		code: DestinationType.CACC,
		description: DestinationTypeDescription[DestinationType.CACC],
	},
	{
		code: DestinationType.TRAN,
		description: DestinationTypeDescription[DestinationType.TRAN],
	},
	{
		code: DestinationType.SLRY,
		description: DestinationTypeDescription[DestinationType.SLRY],
	},
	{
		code: DestinationType.SVGS,
		description: DestinationTypeDescription[DestinationType.SVGS],
	},
] as const;

const DOCUMENT_TYPE_ROWS = [
	{ code: 'CPF', description: 'Cadastro de Pessoa Física' },
	{ code: 'CNPJ', description: 'Cadastro Nacional da Pessoa Jurídica' },
] as const;

const PIX_KEY_CODES = ['CPF', 'CNPJ', 'EMAIL', 'PHONE', 'EVP'] as const;

const TRANSFER_TYPE_CODES = [PaymentType.PIX, PaymentType.TED] as const;

const ImportCsvHelperModal = ({
	isOpen,
	onClose,
}: IImportCsvHelperModalProps) => {
	return (
		<Modal
			isOpen={isOpen}
			title="Guia de preenchimento do CSV"
			width={520}
			onClose={onClose}
		>
			<>
				<BackgroundModalData style={{ marginBottom: '1.5rem' }}>
					<Row align="middle" style={{ gap: '0.5rem' }}>
						<TextS color={theme.textSecondary}>
							Utilize os códigos abaixo para preencher
							corretamente as colunas do arquivo CSV.
						</TextS>
					</Row>
				</BackgroundModalData>
				<SectionContainer>
					<SectionTitle>Tipo de conta</SectionTitle>
					<HelperTable>
						<HelperThead>
							<tr>
								<HelperTh>
									<TextS weight="bold">Código</TextS>
								</HelperTh>
								<HelperTh>
									<TextS weight="bold">Descrição</TextS>
								</HelperTh>
							</tr>
						</HelperThead>
						<tbody>
							{ACCOUNT_TYPE_ROWS.map(({ code, description }) => (
								<HelperTr key={code}>
									<HelperTd>
										<TextS>{code}</TextS>
									</HelperTd>
									<HelperTd>
										<TextS>{description}</TextS>
									</HelperTd>
								</HelperTr>
							))}
						</tbody>
					</HelperTable>
				</SectionContainer>

				<SectionContainer>
					<SectionTitle>Tipo de documento</SectionTitle>
					<HelperTable>
						<HelperThead>
							<tr>
								<HelperTh>
									<TextS weight="bold">Código</TextS>
								</HelperTh>
								<HelperTh>
									<TextS weight="bold">Descrição</TextS>
								</HelperTh>
							</tr>
						</HelperThead>
						<tbody>
							{DOCUMENT_TYPE_ROWS.map(({ code, description }) => (
								<HelperTr key={code}>
									<HelperTd>
										<TextS>{code}</TextS>
									</HelperTd>
									<HelperTd>
										<TextS>{description}</TextS>
									</HelperTd>
								</HelperTr>
							))}
						</tbody>
					</HelperTable>
				</SectionContainer>

				<SectionContainer>
					<SectionTitle>Tipo de chave PIX</SectionTitle>
					<HelperTable>
						<HelperThead>
							<tr>
								<HelperTh>
									<TextS weight="bold">Código</TextS>
								</HelperTh>
							</tr>
						</HelperThead>
						<tbody>
							{PIX_KEY_CODES.map(code => (
								<HelperTr key={code}>
									<HelperTd>
										<TextS>{code}</TextS>
									</HelperTd>
								</HelperTr>
							))}
						</tbody>
					</HelperTable>
				</SectionContainer>

				<SectionContainer>
					<SectionTitle>Tipo de movimentação</SectionTitle>
					<HelperTable>
						<HelperThead>
							<tr>
								<HelperTh>
									<TextS weight="bold">Código</TextS>
								</HelperTh>
							</tr>
						</HelperThead>
						<tbody>
							{TRANSFER_TYPE_CODES.map(code => (
								<HelperTr key={code}>
									<HelperTd>
										<TextS>{code}</TextS>
									</HelperTd>
								</HelperTr>
							))}
						</tbody>
					</HelperTable>
				</SectionContainer>
			</>
		</Modal>
	);
};

export default ImportCsvHelperModal;
